import environment from 'environment';

class NavbarController {
  constructor(NavbarService, SessionService, PageService) {
    'ngInject';

    this.NavbarService = NavbarService;
    this.SessionService = SessionService;
    this.PageService = PageService;

    this.mobileSiteRedirectUrl = environment.MOBILE_SITE_REDIRECT_URL;
  }

  $onInit() {
    this.NavbarService.initialize();
  }

  $onDestroy() {
    this.NavbarService.destroy();
  }

  get model() {
    return this.NavbarService.model;
  }

  get hasBrokerage() {
    return +this.model.brokerageSyncId !== 0;
  }

  get isAffiliate() {
    return this.model.tags.includes('AFF');
  }

  showSettingsModal() {
    this.PageService.showModal('settingsModal');
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/shared/ui/navbar/navbar.controller.js